var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpteraLib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.1 99.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    className: "st0",
    d: "M105.74,86.7c-12.7,7.11-27.2,2.51-34.6-13.21c-7.4-15.72-2.86-32.65-2.86-32.65s27.33,11.35,36.07,13.02 c8.74,1.67,11.35-11.72,3.16-13.95s-39.23-9.28-39.23-9.28l1-7.19c0,0,41.4,9.67,50.33,2.6c8.93-7.07,3.35-14.31-3.49-14.31H78.98 c0.27-0.86,0.42-1.77,0.42-2.72C79.4,4.04,75.36,0,70.38,0c-3.58,0-6.66,2.09-8.12,5.11C60.8,2.09,57.71,0,54.14,0 c-4.98,0-9.03,4.04-9.03,9.03c0,0.95,0.15,1.86,0.42,2.72H8.11c-6.84,0-12.42,7.24-3.49,14.31c8.93,7.07,50.33-2.6,50.33-2.6l1,7.19 c0,0-31.05,7.04-39.23,9.28s-5.58,15.63,3.16,13.95c8.74-1.67,36.07-13.02,36.07-13.02s-1.56,19.44,4,33.58 c5.56,14.14,21.66,29.09,38.63,23.35c18.14-6.14,29.39-15.38,28.47-18.98C126.23,75.62,118.52,79.54,105.74,86.7z M54.14,15.52 c-3.59,0-6.5-2.91-6.5-6.5s2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5S57.72,15.52,54.14,15.52z M63.88,9.03c0-3.59,2.91-6.5,6.5-6.5 c3.59,0,6.5,2.91,6.5,6.5s-2.91,6.5-6.5,6.5C66.79,15.52,63.88,12.61,63.88,9.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpteraLib);
export default __webpack_public_path__ + "static/media/optera-lib.b12e181763a715deaee58b5bf3e460c4.svg";
export { ForwardRef as ReactComponent };